jQuery( document ).ready(function( $ ) {

	// $(document).foundation();

	// Init Skrollr
    var s = skrollr.init({
        render: function(data) {
            //Debugging - Log the current scroll position.
            //console.log(data.curTop);
        },
        forceHeight:false,
        skrollrBody:'skrollr-body'
    });
});